import { Navigate } from "react-router-dom";
import { useStaffAuth } from "../context/StaffAuthContext";

const StaffProtectedRoute = ({ children }) => {
  const { loading, isAuthenticated } = useStaffAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 text-neutral-500 dark:text-neutral-400">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/employee-login" replace />;
  }

  return children;
};

export default StaffProtectedRoute;
